// extracted by mini-css-extract-plugin
export default {"graph":"weeklyHeatMap_graph__Vw3MM","slot":"weeklyHeatMap_slot__lErKe"};